<template>
  <div
    class="modal fade"
    id="AppRegistrationModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.ARM001 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div v-html="lang.ARM002" style="display: flex; flex-direction: column; align-items: center;"></div>
          <div v-if="!shopperAppIdExists" v-html="lang.ARM004"></div>
          <br>
          <a 
            v-if="!shopperAppIdExists"
            :href="registrationLink"
            target="_blank"
            class="registration-btn"
            @click="close()"
          >{{ lang.ARM003 }}</a> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppRegistrationModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      UserId: null,
      registrationLink: null,
      shopperAppIdExists: false,
      lang: {
        ARM001: "🎉 Welcome to the future of Mystery Shopping!",
        ARM002: "<p>Starting from <strong>11. March 2024</strong>, this website will be replaced by our brand-new <strong>CHEX App</strong>!</p><p>🚀 Your benefits with the new CHEX App:</p> <ul style=\"width: 60%;\"> <li>More intuitive navigation & modern design</li> <li>Faster access to exciting missions</li> <li>Better overview of your assignments</li> <li>Easier documentation of your Chex</li> </ul> <p>📱 The Chex App will soon be available in the <strong>Apple App Store</strong> and <strong>Google Play Store</strong>!</p>",
        ARM003: "Sign up",
        ARM004: "<p>Click on \"Sign Up\" now to activate your current account for Chex and get started right away! 🎯</p>"
      }
    }
  },
  mounted() {
    $("#AppRegistrationModal").on("hide.bs.modal", (e) =>
      this.$emit("close")
    );
    $("#AppRegistrationModal").on("show.bs.modal", (e) =>{
      this.UserId = this.globals.currentUserInfo.UserId;
      this.GetRegistrationUrl();
    });
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  watch: {
    showModal() {
      this.showModal ? this.open() : this.close();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  methods: {
    async GetShopperAppIdExists() {
      await $.ajax({
        method: "GET",
        url: "shopper-api/Profile/ShopperAppIdExists",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shopperAppIdExists = data.ShopperAppIdExists;
        },
        error: (error) => {
          console.error("Error on GET in GetShopperAppIdExists()", error);
        },
      });
    },
    open() {
      this.GetShopperAppIdExists();
      this.$nextTick(() => {
        $("#AppRegistrationModal").modal("show");
      });
    },
    close() {
      $("#AppRegistrationModal").modal("hide");
    },
    async GetRegistrationUrl() {
      await $.ajax({
        method: "GET",
        url: `shopper-api/AppRegistration/GetRegistrationUrl`,
        success: (data) => {
          this.registrationLink = data;
        },
        error: (error) => {
          console.error("Error on GET in GetRegistrationUrl()", error);
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.registration-btn {
  padding: 10px;
  background-color: var(--color-primary);
  border-radius: 5px;
  color: white;
  font-size: 14pt;
  text-decoration: none;
  min-width: 20%;
}
.registration-btn:hover {
  background-color: var(--color-primary-input-hover);
}
</style>



// WEBPACK FOOTER //
// AppRegistrationModal.vue?30ef4b0f